import { render, staticRenderFns } from "./TeacherDashboard.vue?vue&type=template&id=12e0aa03&scoped=true"
import script from "./TeacherDashboard.vue?vue&type=script&lang=ts"
export * from "./TeacherDashboard.vue?vue&type=script&lang=ts"
import style0 from "./TeacherDashboard.vue?vue&type=style&index=0&id=12e0aa03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e0aa03",
  null
  
)

export default component.exports